module.exports = __webpack_public_path__ + "img/mooring-point.eeacd064.svg";